import { HttpInterceptorFn } from '@angular/common/http';
import { EncryptionService } from '../shared/interfaces/encrypt';
import { environment } from '../../environments/environment';

export const authInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  
  const encryptedToken = EncryptionService.encryptData(environment.apiPublicKey,environment.apiKey);

  const authReq = req.clone({

    setHeaders: {
      'Authorization': `Bearer ${encryptedToken}`,
      'X-APP-ID': environment.appId,
      'Accept': 'Application/json',
      'Content-Type': 'Application/json'
    }

  });
  
  return next(authReq);
};
